var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDomain4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 55 49",
    width: 55,
    height: 49,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M53.15 34.3L47.79 33.52L45.4 28.67L44.5 26.85L43.6 28.67L41.21 33.52L38.06 33.98L38.23 34.96L41.87 34.43L44.5 29.11L47.11 34.4L47.13 34.43L53 35.29L48.75 39.43L49.75 45.27L44.5 42.51L39.25 45.27L40.25 39.43L38.74 37.96L39.03 39.63L39.18 39.78L38.26 45.11L37.92 47.1L39.71 46.16L44.5 43.64L49.29 46.16L51.08 47.1L50.74 45.11L49.82 39.78L53.7 36L55.15 34.59L53.15 34.3Z",
    id: "a11iYXRayg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.75 39.73L17.02 38.19L15.75 39.43L16.75 45.27L11.5 42.51L6.25 45.27L7.25 39.43L3 35.29L8.87 34.43L11.5 29.11L14.11 34.4L14.13 34.43L17.58 34.93L17.75 33.95L14.79 33.52L12.4 28.67L11.5 26.85L10.6 28.67L8.21 33.52L2.86 34.3L0.85 34.59L2.3 36L6.18 39.78L5.26 45.11L4.92 47.1L6.71 46.16L11.5 43.64L16.29 46.16L18.08 47.1L17.74 45.11L16.82 39.78L16.75 39.73Z",
    id: "abZh6a2cj"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.87 17.98L31.9 18.05L32.13 18.54L32.67 18.62L41.64 19.93L35.14 26.25L34.77 26.62L34.86 27.14L36.39 36.07L28.37 31.85L27.9 31.61L27.43 31.85L19.41 36.07L20.94 27.14L21.03 26.62L20.66 26.25L14.16 19.92L23.14 18.62L23.66 18.54L23.89 18.07L27.9 9.94L27.9 9.94L31.87 17.98ZM22.99 17.63L12.01 19.23L19.96 26.97L18.08 37.9L27.9 32.74L37.72 37.9L35.84 26.97L43.79 19.23L32.81 17.63L32.78 17.56L27.9 7.69L27.9 7.69L22.99 17.63Z",
    id: "e2Sf0OE9o"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.87 17.98L31.9 18.05L32.13 18.54L32.67 18.62L41.64 19.93L35.14 26.25L34.77 26.62L34.86 27.14L36.39 36.07L28.37 31.85L27.9 31.61L27.43 31.85L19.41 36.07L20.94 27.14L21.03 26.62L20.66 26.25L14.16 19.92L23.14 18.62L23.66 18.54L23.89 18.07L27.9 9.94L27.9 9.94L31.87 17.98ZM22.99 17.63L12.01 19.23L19.96 26.97L18.08 37.9L27.9 32.74L37.72 37.9L35.84 26.97L43.79 19.23L32.81 17.63L32.78 17.56L27.9 7.69L27.9 7.69L22.99 17.63Z",
    id: "b2E8zjxMQJ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.61 12.48C12.61 12.48 12.61 12.48 12.61 12.48C12.16 12.87 11.91 13.1 11.86 13.14C11.86 13.14 11.86 13.14 11.86 13.14C6.71 7.34 3.85 4.12 3.28 3.48C3.28 3.48 3.28 3.48 3.28 3.48C3.73 3.08 3.98 2.86 4.03 2.81C4.03 2.81 4.03 2.81 4.03 2.81C9.17 8.61 12.03 11.83 12.61 12.48Z",
    id: "cgR34E34V"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.52 11.77C18.52 11.77 18.52 11.77 18.52 11.77C17.94 11.94 17.62 12.04 17.56 12.06C17.56 12.06 17.56 12.06 17.56 12.06C15.64 5.53 14.58 1.9 14.36 1.18C14.36 1.18 14.36 1.18 14.36 1.18C14.94 1.01 15.26 0.92 15.32 0.9C15.32 0.9 15.32 0.9 15.32 0.9C17.24 7.42 18.31 11.05 18.52 11.77Z",
    id: "aByl6ikTV"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.15 18.58C46.15 18.58 46.15 18.58 46.15 18.58C45.94 18.02 45.82 17.7 45.8 17.64C45.8 17.64 45.8 17.64 45.8 17.64C51.11 15.68 54.06 14.6 54.65 14.38C54.65 14.38 54.65 14.38 54.65 14.38C54.86 14.94 54.98 15.25 55 15.32C55 15.32 55 15.32 55 15.32C49.69 17.27 46.74 18.36 46.15 18.58Z",
    id: "cnfl4Tf5R"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6 3.48C52.6 3.48 52.6 3.48 52.6 3.48C47.46 9.28 44.6 12.5 44.02 13.14C44.02 13.14 44.02 13.14 44.02 13.14C43.58 12.74 43.33 12.52 43.28 12.48C43.28 12.48 43.28 12.48 43.28 12.48C48.42 6.68 51.28 3.46 51.86 2.81C51.86 2.81 51.86 2.81 51.86 2.81C52.3 3.21 52.55 3.43 52.6 3.48Z",
    id: "c2IDGktATJ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.54 17.14C10.54 17.14 10.54 17.14 10.54 17.14C10.33 17.7 10.22 18.01 10.2 18.07C10.2 18.07 10.2 18.07 10.2 18.07C4.88 16.12 1.93 15.03 1.34 14.81C1.34 14.81 1.34 14.81 1.34 14.81C1.55 14.25 1.67 13.94 1.69 13.88C1.69 13.88 1.69 13.88 1.69 13.88C7 15.83 9.95 16.92 10.54 17.14Z",
    id: "b4HQ0Odkxt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.52 1.18C41.52 1.18 41.52 1.18 41.52 1.18C39.6 7.71 38.54 11.33 38.32 12.06C38.32 12.06 38.32 12.06 38.32 12.06C37.75 11.89 37.43 11.79 37.36 11.77C37.36 11.77 37.36 11.77 37.36 11.77C39.28 5.25 40.35 1.62 40.56 0.9C40.56 0.9 40.56 0.9 40.56 0.9C41.14 1.07 41.46 1.16 41.52 1.18Z",
    id: "csMtUfuRs"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a11iYXRayg",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a11iYXRayg",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#abZh6a2cj",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#abZh6a2cj",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e2Sf0OE9o",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e2Sf0OE9o",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2E8zjxMQJ",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2E8zjxMQJ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cgR34E34V",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cgR34E34V",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aByl6ikTV",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aByl6ikTV",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cnfl4Tf5R",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cnfl4Tf5R",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c2IDGktATJ",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c2IDGktATJ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b4HQ0Odkxt",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b4HQ0Odkxt",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#csMtUfuRs",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#csMtUfuRs",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomain4);
export default __webpack_public_path__ + "static/media/domain-4.faec4448907b767a6c99264718999d47.svg";
export { ForwardRef as ReactComponent };